export const TrialRouting = {
  path: "/trial",
  name: "trial",
  component: () => import(/* webpackChunkName: "trial" */ "@/views/Invite-trial/index.vue"),
  children: [],
};